import type {Logo} from "@/scripts/Common";

const createEmptyLogo = () => {
    const logo: Logo = {
        id: 0,
        format: '',
        data: '',
    }

    return logo;
}

export {
    createEmptyLogo,
}
